import React, {Component} from 'react';
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import {base} from '../../base';
import '../../styles/css/AdminMain.css';
import InfiniteScroll from 'react-infinite-scroller';

class UserManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usersList: [],
            loading: true,
            page: 1,
            responseSize: 100,
            searchByUserName: 'userName'
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event){
        this.setState({[event.target.name]: event.target.value});
    }

    componentDidMount() {
        this.getUsersAccounts(this.state.responseSize, "");
    }

    async getUsersAccounts(numberToGet, search){
        let searchTerm = 'userName';
        if(this.state.searchByUserName === "email"){
            searchTerm = 'email';
        }
        let queries = {
            limitToFirst: numberToGet,
            orderByChild: searchTerm
        }
        if(search){
            queries['startAt'] = search;
            queries['endAt'] = search+"\uf8ff";
        }
        const usersToReturn = await base.fetch('usernameToEmail', {
            context: this,
            asArray: true,
            queries: queries
        })
        const pageNumberAccurate = numberToGet / this.state.responseSize;
        this.setState({
            usersList: usersToReturn,
            loading: false,
            page: pageNumberAccurate
        })
    }

    async handleLoadMore(page){
        await this.getUsersAccounts(this.state.responseSize*page, document.getElementById('searchQuery').value)
    }

    render() {
        const {loading, usersList=[], searchByUserName} = this.state;
        let placeholderText = "Filter Users By User Name (Case sensitive)";
        if(searchByUserName === "email"){
            placeholderText = "Filter Users By Email (Case sensitive)";
        }
        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <p className="admin-page-eyebrow">Access</p>
                    <p className="admin-header-text">User Management</p>
                <p className="admin-subheader-text">Here you can go through your list of users</p>
                <div className="admin-filterbar">
                    <div className="form-group" style={{ flex: '1 1 260px', maxWidth: 380, marginBottom: 0 }}>
                        <label htmlFor="searchQuery">Find a user</label>
                        <input
                            type="text"
                            id="searchQuery"
                            name="search"
                            className="form-control"
                            placeholder={placeholderText}
                            onChange={()=>{
                                const vm = this;
                                clearTimeout(this.timeoutId); // no-op if invalid id
                                this.timeoutId = setTimeout(async function(){
                                    let input = document.getElementById('searchQuery').value;
                                    await vm.getUsersAccounts(vm.state.responseSize, input);
                                }, 500);}
                            }
                        />
                    </div>
                    {/* the two radios shared one id and their labels sat in a
                        separate grid row, so neither was ever associated */}
                    <fieldset className="admin-radio-inline">
                        <legend>Search by</legend>
                        <span>
                            <input type="radio" name="searchByUserName" id="searchByUserNameOption"
                                   onChange={this.handleChange} value="userName"
                                   checked={this.state.searchByUserName === "userName"}/>
                            <label htmlFor="searchByUserNameOption">User name</label>
                        </span>
                        <span>
                            <input type="radio" name="searchByUserName" id="searchByEmailOption"
                                   onChange={this.handleChange} value="email"
                                   checked={this.state.searchByUserName === "email"}/>
                            <label htmlFor="searchByEmailOption">Email</label>
                        </span>
                    </fieldset>
                </div>
                <div>
                    <div style={{height:700, overflow:"auto"}}>
                        <InfiniteScroll
                            loadMore={(page) => this.handleLoadMore(page)}
                            hasMore={this.state.responseSize*this.state.page === usersList.length}
                            pageStart={0}
                            useWindow={false}
                        >
                            <div className="admin-table-wrap">
                                <table className="table table-striped" style={{color:'black', margin: 20}}>
                                    <tbody>
                                    <tr>
                                        <th>User Name</th>
                                        <th>Email</th>
                                        <th>Uid</th>
                                    </tr>
                                    {
                                        usersList.map(function (item, i) {
                                            let link = `/userinfo?uid=${item.uid}`;
                                            return <tr key={i}>
                                                <td style={{fontFamily:'Open Sans' }}><a href={link}>{item.userName || item.key}</a></td>
                                                <td style={{fontFamily:'Open Sans'}}>{item.email || "None"}</td>
                                                <td style={{fontFamily:'Open Sans'}}>{item.uid}</td>
                                            </tr>
                                        }, this)
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </InfiniteScroll>
                    </div>
                </div>
              </div>
         </div>
        );
    }
}

export default UserManagement
